<template>
  <div class="i_body">
    <div class="i_body_title">个人总览</div>
    <!-- <div class="i_body_panel">
      <div class="i_icon"><span></span></div>
      <div class="i_detail">
        <div><span>{{test.length}}</span><span>个</span></div>
        <div>测评项目总数</div>
      </div>
    </div>
    <div class="i_body_panel">
      <div class="i_icon"><span></span></div>
      <div class="i_detail">
        <div><span>{{work.length}}</span><span>个</span></div>
        <div>已完成</div>
      </div>
    </div>
    <div class="i_body_panel">
      <div class="i_icon"><span></span></div>
      <div class="i_detail">
        <div><span>{{test.length - work.length}}</span><span>个</span></div>
        <div>待完成</div>
      </div>
    </div> -->
    <div class="i_body_panel">
      <div class="i_icon"><span></span></div>
      <div class="i_detail">
        <div><span>{{count1}}</span><span>个</span></div>
        <div>资料提交数</div>
      </div>
    </div>
    <div class="i_body_panel" v-show="oid == '4c686762-1d0a-11ed-8c78-005056b86db5'">
      <div class="i_icon"><span></span></div>
      <div class="i_detail">
        <div><span>{{count2}}</span><span>个</span></div>
        <div>培训活动数</div>
      </div>
    </div>
    <div class="i_body_panel">
      <div class="i_icon"><span></span></div>
      <div class="i_detail">
        <div><span>{{count3}}</span><span>个</span></div>
        <div>教学活动数</div>
      </div>
    </div>
    <div class="i_body_panel">
      <div class="i_icon"><span></span></div>
      <div class="i_detail">
        <div><span>{{count4}}</span><span>个</span></div>
        <div>教研活动数</div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    userid: {
      type: String
    },
    oid: {
      type: String
    },
    org: {
      type: String
    },
  },
  data() {
    return {
      test:  [],
      work: [],
      count1: 0,
      count2: 0,
      count3: 0,
      count4: 0,
    }
  },
  methods: {
    getData() {
      let params = {
        uid: this.userid,
        oid: this.oid,
        org: this.org,
      };
      this.ajax
        .get(this.$store.state.api + "selectTestUserY", params)
        .then((res) => {
          this.test = res.data[0]
          this.work = res.data[1]

          this.count1 = res.data[2].length // 资料提交数
          this.count2 = res.data[3].length //培训活动数
          this.count3 = res.data[4].length //教学活动数
          this.count4 = res.data[5].length //教研活动数

        })
        .catch((err) => {
          console.error(err);
        });
    }
  },
  mounted () {
    this.getData();
  },
}
</script>

<style scoped>
    .i_body{
        width: 100%;
        height: 45%;
        min-height: 315px;
        background: #fff;
        border-radius: 5px;
        overflow: hidden;
    }
    .i_body_title{
      margin: 25px auto 15px;
      font-size: 20px;
      text-align: center;
    }
    .i_body_panel{
      width: 90%;
      display: flex;
      align-items: center;
      padding: 10px 15px;
      box-sizing: border-box;
      border-radius: 5px;
      margin: 0 auto;
      border: 1px solid #dbdbdb;
      background: rgb(252, 252, 252);
    }
    .i_body_panel + .i_body_panel{
      margin-top: 10px;
    }
    .i_body_panel > .i_icon{
      width: 40px;
      height: 40px;
      border-radius: 8px;
      display: flex;
      align-items: center;
      align-items: center;
      justify-content: center;
      margin-right: 10px;
    }
    .i_body_panel:nth-child(2) > .i_icon{
      background: rgb(54, 129, 252);
    }
    .i_body_panel:nth-child(2) > .i_icon > span{
      display: block;
      width: 20px;
      height: 20px;
      background-size:100% 100%;
      background-image: url('../../../../assets/icon/test/zong_1.png');
    }
    .i_body_panel:nth-child(3) > .i_icon{
      background: rgb(23, 196, 105);
    }
    .i_body_panel:nth-child(3) > .i_icon > span{
      display: block;
      width: 20px;
      height: 20px;
      background-size:100% 100%;
      background-image: url('../../../../assets/icon/test/zong_2.png');
    }
    .i_body_panel:nth-child(4) > .i_icon{
      background: rgb(230, 127, 54);
    }
    .i_body_panel:nth-child(4) > .i_icon > span{
      display: block;
      width: 20px;
      height: 20px;
      background-size:100% 100%;
      background-image: url('../../../../assets/icon/test/zong_3.png');
    }
    .i_body_panel:nth-child(5) > .i_icon{
      background: rgb(54, 192, 230);
    }
    .i_body_panel:nth-child(5) > .i_icon > span{
      display: block;
      width: 20px;
      height: 20px;
      background-size:100% 100%;
      background-image: url('../../../../assets/icon/new/test_jy.png');
    }
    .i_body_panel > .i_detail{
      width: clac(100% - 50px);
    }
    .i_body_panel > .i_detail > div:nth-child(1){
      font-size: 12px;
    }

    .i_body_panel > .i_detail > div:nth-child(1) > span:nth-child(1){
      font-size: 18px;
      font-weight: bold;
      margin-right:5px;
    }
    .i_body_panel > .i_detail > div:nth-child(2){
      color: #a1a1a1;
      font-size: 12px;
      margin-top: 0px;
    }
</style>


// WEBPACK FOOTER //
// src/components/pages/testPerson/panel/index.vue